// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Projects ───────────────────────────────────────────── */
.projects-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg);
}
@media (max-width: 768px) {
  .projects-section {
    padding: 60px 5%;
  }
}

.projects-header {
  text-align: center;
  margin-bottom: 56px;
}
.projects-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
  color: var(--text) !important;
}

.projects-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.projects-intro {
  color: var(--text-muted) !important;
  font-size: 0.95rem;
  line-height: 1.7;
  max-width: 600px;
  margin: 0 auto;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-top: 48px;
}

.project-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.project-link--disabled {
  cursor: default;
}

.project-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
}
.project-link:hover .project-card, .project-link--disabled:hover .project-card {
  border-color: var(--accent);
  transform: translateY(-4px);
  box-shadow: var(--shadow);
}
.project-link--disabled:hover .project-card {
  transform: translateY(-2px);
}

.project-image-wrap {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: var(--bg-surface);
}
.project-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}
.project-link:hover .project-image-wrap img {
  transform: scale(1.04);
}

.project-body {
  padding: 20px 20px 18px;
}

.project-tag {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--accent-2) !important;
  margin-bottom: 8px;
}

.project-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text) !important;
  margin: 0 0 10px;
  line-height: 1.4;
}

.project-desc {
  font-size: 0.875rem;
  color: var(--text-muted) !important;
  line-height: 1.6;
  margin: 0 0 14px;
}

.project-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 600;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  background: rgba(96, 165, 250, 0.1);
  color: var(--accent) !important;
  border: 1px solid rgba(96, 165, 250, 0.25);
}

.project-read-more {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--accent) !important;
  display: flex;
  align-items: center;
  gap: 4px;
}
.project-read-more::after {
  content: "→";
  transition: transform 0.2s;
}
.project-link:hover .project-read-more::after {
  transform: translateX(3px);
}

@media (max-width: 700px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Project.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAGF;;AAAA;EACE,qBAAA;EACA,cAAA;EACA,cAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,gBAAA;EACA,8DAAA;AAGF;AADE;EAEE,2BAAA;EACA,2BAAA;EACA,yBAAA;AAEJ;AACE;EACE,2BAAA;AACJ;;AAGA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;AAAJ;AAGE;EACE,sBAAA;AADJ;;AAKA;EACE,uBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,mCAAA;EACA,+BAAA;EACA,0CAAA;AAFF;;AAKA;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;AAIE;EACE,YAAA;EACA,0BAAA;AAFJ;AAMI;EAAW,0BAAA;AAHf;;AAOA;EACE;IAAiB,0BAAA;EAHjB;AACF","sourcesContent":["/* ─── Projects ───────────────────────────────────────────── */\n\n.projects-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.projects-header {\n  text-align: center;\n  margin-bottom: 56px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n    color: var(--text) !important;\n  }\n}\n\n.projects-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto 20px;\n}\n\n.projects-intro {\n  color: var(--text-muted) !important;\n  font-size: 0.95rem;\n  line-height: 1.7;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 24px;\n  margin-top: 48px;\n}\n\n.project-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.project-link--disabled {\n  cursor: default;\n}\n\n.project-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;\n\n  .project-link:hover &,\n  .project-link--disabled:hover & {\n    border-color: var(--accent);\n    transform: translateY(-4px);\n    box-shadow: var(--shadow);\n  }\n\n  .project-link--disabled:hover & {\n    transform: translateY(-2px);\n  }\n}\n\n.project-image-wrap {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  background: var(--bg-surface);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    transition: transform 0.3s ease;\n  }\n\n  .project-link:hover & img {\n    transform: scale(1.04);\n  }\n}\n\n.project-body {\n  padding: 20px 20px 18px;\n}\n\n.project-tag {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--accent-2) !important;\n  margin-bottom: 8px;\n}\n\n.project-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text) !important;\n  margin: 0 0 10px;\n  line-height: 1.4;\n}\n\n.project-desc {\n  font-size: 0.875rem;\n  color: var(--text-muted) !important;\n  line-height: 1.6;\n  margin: 0 0 14px;\n}\n\n.project-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.project-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  background: rgba(96, 165, 250, 0.1);\n  color: var(--accent) !important;\n  border: 1px solid rgba(96, 165, 250, 0.25);\n}\n\n.project-read-more {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--accent) !important;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &::after {\n    content: \"→\";\n    transition: transform 0.2s;\n  }\n\n  .project-link:hover & {\n    &::after { transform: translateX(3px); }\n  }\n}\n\n@media (max-width: 700px) {\n  .projects-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
